module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"step":"список вопросов для интервью","back":"Назад","next":"Далее","end":"Завершить","returnToTemplates":"Вернуться в мастер выбора шаблона"}}')
  delete Component.options._Ctor
}
